import { PageHeader } from '@/components/shared/PageHeader';
import { FunctionsHealthTab } from '@/components/tools/FunctionsHealthTab';

export function FunctionsStatusPage() {
    return (
        <div className="space-y-6">
            <PageHeader
                title="Estado Azure Functions"
                description="Monitorización y salud de las funciones desplegadas (Application Insights)"
            />
            <FunctionsHealthTab />
        </div>
    );
}
